









































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { v4 as uuid } from 'uuid'
import {
	CAMPOS_QUE_DEPENDEM_DE_TABELA_DE_PRECO,
	CampoDeEtiqueta,
	CampoDeEtiquetaDisponivel,
	CampoDoModeloDeEtiqueta,
	TipoDeAlinhamentoDeTexto,
	montarTextoDePrecoDaTabela,
} from '@/models/ModeloDeEtiqueta'
import type { TamanhoDaEtiqueta } from '@/models/EtiquetaDePreco'
import {
	PONTOS_POR_CM,
	QUEBRA_DE_LINHA,
	TextoAjustado,
	ajustarTextoNaCaixa,
} from '@/shareds/etiquetas/ajuste-de-texto-de-etiqueta'
import {
	LARGURA_MINIMA_DO_CODIGO_DE_BARRAS_CM,
	larguraDoSimboloEmCm,
	moduloDoCodigoDeBarrasEmDots,
	moduloEmCm,
	ALTURA_MINIMA_DO_CODIGO_DE_BARRAS_CM,
	LARGURA_MINIMA_PRATICA_DO_CODIGO_DE_BARRAS_CM,
	saiEmEan13,
} from '@/shareds/etiquetas/codigo-de-barras-de-etiqueta'

const EXEMPLOS_DE_TABELA = [
	'CARTAO CREDITO PARCELADO',
	'PIX A VISTA',
	'BOLETO 30 DIAS',
	'CARTAO DEBITO',
	'CREDIARIO',
	'DINHEIRO',
]
const EXEMPLO_LIMITACAO = '- Limitação 999'
const LARGURA_MINIMA_DE_CAMPO_CM = 0.5
const ALTURA_MINIMA_DE_CAMPO_CM = 0.3
const LARGURA_MINIMA_DA_CAIXA_DO_CODIGO_CM = LARGURA_MINIMA_PRATICA_DO_CODIGO_DE_BARRAS_CM

interface ElementoDoEditor {
	chave: string
	campo: CampoDoModeloDeEtiqueta
	indice: number
	texto: string
}

const ESCALA_MAXIMA_PX_POR_CM = 55
const LARGURA_MAXIMA_DO_CANVAS_PX = 800

const ICONE_POR_CAMPO: Record<CampoDeEtiqueta, string> = {
	NOME_DA_LOJA: 'mdi-storefront-outline',
	SKU_PRODUTO_PAI: 'mdi-tag-outline',
	SKU_PRODUTO: 'mdi-pound',
	NOME_DO_PRODUTO: 'mdi-package-variant',
	CODIGO_DE_BARRAS: 'mdi-barcode',
	TEXTO_DO_EAN: 'mdi-numeric',
	PRECO_DO_PRODUTO: 'mdi-currency-usd',
	PRECO_DA_TABELA: 'mdi-cash-multiple',
	TRACO: 'mdi-minus',
}

@Component
export default class EditorDeLayoutDeEtiqueta extends Vue {
	@Prop({ type: Array, required: true }) value!: CampoDoModeloDeEtiqueta[]
	@Prop({ type: Object, required: true }) tamanho!: TamanhoDaEtiqueta
	@Prop({ type: Array, required: true }) camposDisponiveis!: CampoDeEtiquetaDisponivel[]

	campos: CampoDoModeloDeEtiqueta[] = []
	campoSelecionadoIndex: number | null = null

	arrastando: { indice: number; offsetXPx: number; offsetYPx: number; origemXPx: number; origemYPx: number } | null = null
	redimensionando: { indice: number; offsetXPx: number; offsetYPx: number; origemXPx: number; origemYPx: number } | null = null
	tabelasSimuladas = 1
	maximoDeTabelasSimuladas = EXEMPLOS_DE_TABELA.length
	avisosCongelados: string[] | null = null

	@Watch('tabelasSimuladas')
	aoMudarAsTabelasSimuladas(quantidade: number) {
		this.$emit('tabelas-simuladas', quantidade)
	}

	created() {
		this.campos = this.value || []
	}

	get escala(): number {
		const largura = this.tamanho.larguraEtiqueta || 1
		return Math.min(ESCALA_MAXIMA_PX_POR_CM, LARGURA_MAXIMA_DO_CANVAS_PX / largura)
	}

	get estiloDoCanvas() {
		return {
			width: `${(this.tamanho.larguraEtiqueta || 0) * this.escala}px`,
			height: `${(this.tamanho.alturaEtiqueta || 0) * this.escala}px`,
		}
	}

	get campoSelecionado(): CampoDoModeloDeEtiqueta | null {
		if (this.campoSelecionadoIndex === null) return null
		return this.campos[this.campoSelecionadoIndex] || null
	}

	get campoDependeDeTabela(): boolean {
		const campo = this.campoSelecionado?.campo
		return !!campo && CAMPOS_QUE_DEPENDEM_DE_TABELA_DE_PRECO.includes(campo)
	}

	get temCampoQueDependeDeTabela(): boolean {
		return this.campos.some(campo => this.dependeDeTabela(campo))
	}

	get elementos(): ElementoDoEditor[] {
		return this.campos.map((campo, indice) => ({
			chave: campo.id,
			campo,
			indice,
			texto: this.textoDoCampo(campo),
		}))
	}

	get avisosDeSobreposicao(): string[] {
		return this.avisosCongelados || this.calcularAvisosDeSobreposicao()
	}

	calcularAvisosDeSobreposicao(): string[] {
		const avisos: string[] = []
		for (let i = 0; i < this.campos.length; i++) {
			for (let j = i + 1; j < this.campos.length; j++) {
				if (this.seSobrepoem(this.campos[i], this.campos[j])) {
					avisos.push(`${this.rotuloDoCampo(this.campos[i])} e ${this.rotuloDoCampo(this.campos[j])}`)
				}
			}
		}
		return avisos
	}

	dependeDeTabela(campo: CampoDoModeloDeEtiqueta): boolean {
		return !!campo.campo && CAMPOS_QUE_DEPENDEM_DE_TABELA_DE_PRECO.includes(campo.campo)
	}

	textoDoCampo(campo: CampoDoModeloDeEtiqueta): string {
		if (campo.campo !== 'PRECO_DA_TABELA') {
			return this.valorDeExemploDoCatalogo(campo.campo)
		}
		const linhas: string[] = []
		for (let tabela = 0; tabela < this.tabelasSimuladas; tabela += 1) {
			linhas.push(montarTextoDePrecoDaTabela(
				campo,
				EXEMPLOS_DE_TABELA[tabela % EXEMPLOS_DE_TABELA.length],
				this.valorDeExemploDoCatalogo('PRECO_DA_TABELA'),
				EXEMPLO_LIMITACAO,
			))
		}
		return linhas.join(QUEBRA_DE_LINHA)
	}

	get codigosDeBarrasQueSairaoEmCode128(): string[] {
		return this.campos
			.filter(campo => campo.campo === 'CODIGO_DE_BARRAS' && !saiEmEan13(campo.largura, campo.altura))
			.map(campo => this.rotuloDoCampo(campo))
	}

	get larguraMinimaDoCodigoDeBarrasFormatada(): string {
		return LARGURA_MINIMA_DO_CODIGO_DE_BARRAS_CM.toFixed(2).replace('.', ',')
	}

	get campoSelecionadoEhCodigoDeBarras(): boolean {
		return this.campoSelecionado?.campo === 'CODIGO_DE_BARRAS'
	}

	get alturaMinimaDoCodigoFormatada(): string {
		return ALTURA_MINIMA_DO_CODIGO_DE_BARRAS_CM.toFixed(2).replace('.', ',')
	}

	ajustarCodigoParaMenorEan13() {
		const campo = this.campoSelecionado
		if (!campo) return
		const larguraEtiqueta = this.tamanho.larguraEtiqueta || 0
		const alturaEtiqueta = this.tamanho.alturaEtiqueta || 0

		campo.largura = Math.min(LARGURA_MINIMA_DA_CAIXA_DO_CODIGO_CM, larguraEtiqueta)
		campo.altura = Math.min(ALTURA_MINIMA_DO_CODIGO_DE_BARRAS_CM, alturaEtiqueta)
		campo.x = this.arredondar(this.clamp(campo.x, 0, larguraEtiqueta - campo.largura))
		campo.y = this.arredondar(this.clamp(campo.y, 0, alturaEtiqueta - campo.altura))
		this.emitirMudanca()
	}


	get ajustesPorElemento(): Record<string, TextoAjustado> {
		const ajustes: Record<string, TextoAjustado> = {}
		for (const elemento of this.elementos) {
			if (this.tipoDeDado(elemento.campo) === 'GRAFICO') continue
			ajustes[elemento.chave] = ajustarTextoNaCaixa(
				elemento.texto, elemento.campo.tamanhoDaFonte, elemento.campo.largura, elemento.campo.altura, elemento.campo.negrito,
			)
		}
		return ajustes
	}

	linhasDoElemento(elemento: ElementoDoEditor): string[] {
		return this.ajustesPorElemento[elemento.chave]?.linhas || []
	}

	estiloDoTextoDoElemento(elemento: ElementoDoEditor) {
		const ajuste = this.ajustesPorElemento[elemento.chave]
		if (!ajuste) return {}
		return {
			fontSize: `${(ajuste.tamanhoDaFontePt / PONTOS_POR_CM) * this.escala}px`,
			lineHeight: `${(ajuste.alturaDaLinhaPt / PONTOS_POR_CM) * this.escala}px`,
		}
	}

	estiloDasBarras(campo: CampoDoModeloDeEtiqueta) {
		const ehEan13 = saiEmEan13(campo.largura, campo.altura)
		const moduloEmDots = moduloDoCodigoDeBarrasEmDots(campo.largura)
		const modulo = Math.max(1, moduloEmCm(ehEan13 ? moduloEmDots : 1) * this.escala)
		return {
			width: `${(ehEan13 ? larguraDoSimboloEmCm(moduloEmDots) : campo.largura) * this.escala}px`,
			backgroundImage: 'repeating-linear-gradient(90deg,'
				+ `#111 0, #111 ${modulo}px,`
				+ `transparent ${modulo}px, transparent ${modulo * 2}px,`
				+ `#111 ${modulo * 2}px, #111 ${modulo * 4}px,`
				+ `transparent ${modulo * 4}px, transparent ${modulo * 5}px,`
				+ `#111 ${modulo * 5}px, #111 ${modulo * 6}px,`
				+ `transparent ${modulo * 6}px, transparent ${modulo * 8}px)`,
		}
	}

	seSobrepoem(a: CampoDoModeloDeEtiqueta, b: CampoDoModeloDeEtiqueta): boolean {
		const cruzaNoEixoX = a.x + a.largura > b.x && b.x + b.largura > a.x
		const cruzaNoEixoY = a.y + a.altura > b.y && b.y + b.altura > a.y
		return cruzaNoEixoX && cruzaNoEixoY
	}

	iconeDoCampo(chave: CampoDeEtiqueta): string {
		return ICONE_POR_CAMPO[chave] || 'mdi-format-text'
	}

	tipoDeDado(campo: CampoDoModeloDeEtiqueta): string {
		return this.camposDisponiveis.find(disponivel => disponivel.chave === campo.campo)?.tipoDeDado || 'TEXTO'
	}

	rotuloDoCampo(campo: CampoDoModeloDeEtiqueta): string {
		return this.camposDisponiveis.find(disponivel => disponivel.chave === campo.campo)?.rotulo || ''
	}

	valorDeExemploDoCatalogo(chave: CampoDeEtiqueta | null): string {
		return this.camposDisponiveis.find(disponivel => disponivel.chave === chave)?.valorDeExemplo || ''
	}

	estiloDoElemento(elemento: ElementoDoEditor) {
		const alinhamento: Record<TipoDeAlinhamentoDeTexto, string> = {
			ESQUERDA: 'left',
			CENTRO: 'center',
			DIREITA: 'right',
		}
		const campo = elemento.campo
		return {
			left: `${campo.x * this.escala}px`,
			top: `${campo.y * this.escala}px`,
			width: `${campo.largura * this.escala}px`,
			height: `${campo.altura * this.escala}px`,
			fontWeight: campo.negrito ? 'bold' : 'normal',
			textAlign: alinhamento[campo.alinhamento] || 'left',
			justifyContent: alinhamento[campo.alinhamento] === 'center' ? 'center' : alinhamento[campo.alinhamento] === 'right' ? 'flex-end' : 'flex-start',
			zIndex: elemento.indice === this.campoSelecionadoIndex ? 2 : 1,
		}
	}

	adicionarCampo(disponivel: CampoDeEtiquetaDisponivel, xCm?: number, yCm?: number) {
		const ehCodigoDeBarras = disponivel.chave === 'CODIGO_DE_BARRAS'
		const larguraEtiqueta = this.tamanho.larguraEtiqueta || 0
		const alturaEtiqueta = this.tamanho.alturaEtiqueta || 0
		const largura = ehCodigoDeBarras
			? Math.min(LARGURA_MINIMA_DA_CAIXA_DO_CODIGO_CM, larguraEtiqueta)
			: Math.min(3, larguraEtiqueta || 3)
		const altura = ehCodigoDeBarras
			? Math.min(ALTURA_MINIMA_DO_CODIGO_DE_BARRAS_CM, alturaEtiqueta)
			: 1
		const novoCampo: CampoDoModeloDeEtiqueta = {
			id: uuid(),
			campo: disponivel.chave,
			x: this.clamp(xCm ?? 0, 0, (this.tamanho.larguraEtiqueta || 0) - largura),
			y: this.clamp(yCm ?? this.primeiroYLivre(altura), 0, (this.tamanho.alturaEtiqueta || 0) - altura),
			largura,
			altura,
			tamanhoDaFonte: 8,
			negrito: false,
			alinhamento: 'ESQUERDA',
			tipoDeCodigoDeBarras: disponivel.requerTipoDeCodigoDeBarras ? 'EAN13' : null,
			incluirNomeDaTabela: false,
			incluirLimitacao: false,
		}
		this.campos.push(novoCampo)
		this.campoSelecionadoIndex = this.campos.length - 1
		this.emitirMudanca()
	}

	primeiroYLivre(alturaDoCampo: number): number {
		const abaixoDeTudo = this.campos.reduce((maior, campo) => Math.max(maior, campo.y + campo.altura), 0)
		return abaixoDeTudo + alturaDoCampo <= (this.tamanho.alturaEtiqueta || 0) ? abaixoDeTudo : 0
	}

	iniciarArrasteDaPaleta(evento: DragEvent, disponivel: CampoDeEtiquetaDisponivel) {
		if (evento.dataTransfer) {
			evento.dataTransfer.setData('text/plain', disponivel.chave)
			evento.dataTransfer.effectAllowed = 'copy'
		}
	}

	soltarNaPaleta(evento: DragEvent) {
		const chave = evento.dataTransfer?.getData('text/plain') as CampoDeEtiqueta | undefined
		const disponivel = this.camposDisponiveis.find(item => item.chave === chave)
		if (!disponivel) return

		const containerRect = (this.$refs.canvas as HTMLElement).getBoundingClientRect()
		const xCm = (evento.clientX - containerRect.left) / this.escala
		const yCm = (evento.clientY - containerRect.top) / this.escala
		this.adicionarCampo(disponivel, xCm, yCm)
	}

	removerCampoSelecionado() {
		if (this.campoSelecionadoIndex === null) return
		const campo = this.campos[this.campoSelecionadoIndex]
		campo.incluirNomeDaTabela = false
		campo.incluirLimitacao = false
		this.campos.splice(this.campoSelecionadoIndex, 1)
		this.campoSelecionadoIndex = null
		this.emitirMudanca()
	}

	selecionarCampo(indice: number) {
		this.campoSelecionadoIndex = indice
	}

	deselecionarCampo() {
		this.campoSelecionadoIndex = null
	}

	iniciarArraste(evento: MouseEvent, indice: number) {
		this.selecionarCampo(indice)
		this.avisosCongelados = this.calcularAvisosDeSobreposicao()
		const containerRect = (this.$refs.canvas as HTMLElement).getBoundingClientRect()
		const campo = this.campos[indice]
		this.arrastando = {
			indice,
			offsetXPx: evento.clientX - (containerRect.left + campo.x * this.escala),
			offsetYPx: evento.clientY - (containerRect.top + campo.y * this.escala),
			origemXPx: containerRect.left,
			origemYPx: containerRect.top,
		}
		window.addEventListener('mousemove', this.moverArraste)
		window.addEventListener('mouseup', this.finalizarArraste)
	}

	moverArraste(evento: MouseEvent) {
		if (!this.arrastando) return
		const campo = this.campos[this.arrastando.indice]
		if (!campo) return

		const xCm = (evento.clientX - this.arrastando.origemXPx - this.arrastando.offsetXPx) / this.escala
		const yCm = (evento.clientY - this.arrastando.origemYPx - this.arrastando.offsetYPx) / this.escala

		campo.x = this.arredondar(this.clamp(xCm, 0, (this.tamanho.larguraEtiqueta || 0) - campo.largura))
		campo.y = this.arredondar(this.clamp(yCm, 0, (this.tamanho.alturaEtiqueta || 0) - campo.altura))
	}

	finalizarArraste() {
		window.removeEventListener('mousemove', this.moverArraste)
		window.removeEventListener('mouseup', this.finalizarArraste)
		this.arrastando = null
		this.avisosCongelados = null
		this.emitirMudanca()
	}

	iniciarRedimensionamento(evento: MouseEvent, indice: number) {
		this.avisosCongelados = this.calcularAvisosDeSobreposicao()
		const campo = this.campos[indice]
		const containerRect = (this.$refs.canvas as HTMLElement).getBoundingClientRect()
		this.redimensionando = {
			indice,
			offsetXPx: evento.clientX - (containerRect.left + (campo.x + campo.largura) * this.escala),
			offsetYPx: evento.clientY - (containerRect.top + (campo.y + campo.altura) * this.escala),
			origemXPx: containerRect.left,
			origemYPx: containerRect.top,
		}
		window.addEventListener('mousemove', this.moverRedimensionamento)
		window.addEventListener('mouseup', this.finalizarRedimensionamento)
	}

	moverRedimensionamento(evento: MouseEvent) {
		if (!this.redimensionando) return
		const campo = this.campos[this.redimensionando.indice]
		if (!campo) return

		const larguraEtiqueta = this.tamanho.larguraEtiqueta || 0
		const bordaDireitaCm = (evento.clientX - this.redimensionando.offsetXPx - this.redimensionando.origemXPx) / this.escala
		const bordaInferiorCm = (evento.clientY - this.redimensionando.offsetYPx - this.redimensionando.origemYPx) / this.escala

		const alturaEtiqueta = this.tamanho.alturaEtiqueta || 0
		campo.largura = this.arredondar(this.clamp(bordaDireitaCm - campo.x, LARGURA_MINIMA_DE_CAMPO_CM, larguraEtiqueta - campo.x))
		campo.altura = this.arredondar(this.clamp(bordaInferiorCm - campo.y, ALTURA_MINIMA_DE_CAMPO_CM, alturaEtiqueta - campo.y))
	}

	finalizarRedimensionamento() {
		window.removeEventListener('mousemove', this.moverRedimensionamento)
		window.removeEventListener('mouseup', this.finalizarRedimensionamento)
		this.redimensionando = null
		this.avisosCongelados = null
		this.emitirMudanca()
	}

	clamp(valor: number, minimo: number, maximo: number): number {
		if (maximo < minimo) return minimo
		return Math.min(Math.max(valor, minimo), maximo)
	}

	arredondar(valor: number): number {
		return Math.round(valor * 10) / 10
	}

	emitirMudanca() {
		this.$emit('input', this.campos)
	}

	@Watch('campoSelecionado', { deep: true })
	onAlterarPropriedadesDoCampo() {
		this.emitirMudanca()
	}

	beforeDestroy() {
		window.removeEventListener('mousemove', this.moverArraste)
		window.removeEventListener('mouseup', this.finalizarArraste)
		window.removeEventListener('mousemove', this.moverRedimensionamento)
		window.removeEventListener('mouseup', this.finalizarRedimensionamento)
		window.removeEventListener('keydown', this.aoPressionarDelete)
	}

	mounted() {
		window.addEventListener('keydown', this.aoPressionarDelete)
	}

	aoPressionarDelete(evento: KeyboardEvent) {
		if (evento.key !== 'Delete') return
		if (this.campoSelecionadoIndex === null) return
		const alvo = evento.target as HTMLElement | null
		if (alvo && (alvo.tagName === 'INPUT' || alvo.tagName === 'TEXTAREA' || alvo.isContentEditable)) return
		this.removerCampoSelecionado()
	}

}
